// extracted by mini-css-extract-plugin
export default {"container":"LandmarkGroup_container__EfsdA","mapWrapper":"LandmarkGroup_mapWrapper__YLHqi"};